import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';

@Injectable({providedIn: 'root'})
export class CompanyDataService {

    constructor(private http: HttpClient) {
    }

    addCompanyData(company: object) {
        return this.http.post('agri/createCompanyWithUser', company);
    }

    getCompanyData(companyId) {
        return this.http.get('agri/getCompanyById?companyId=' + companyId);
    }

    getCurrentUserCompany() {
        return this.http.get('agri/getCurrentUserCompany');
    }

    updateCompanyData(companyId, company: object) {
        return this.http.put('agri/updateCompany?companyId=' + companyId, company);
    }

    getJobsFromCompany() {
        return this.http.get('agri/getJobsFromCurrentCompany');
    }

    // Change Job Status
    changeJobStatus(jobId: any, status: string) {
        return this.http.put('agri/changeJobStatus?jobId=' + jobId + '&status=' + status, {})
    }

    // Post Company Review
    postCompanyReview(reviewData: object) {
        return this.http.post('agri/reviewCompany', reviewData);
    }

    getReviewNumbers(companyId) {
        return this.http.get('agri/numberOfReviewsForACompany?companyId=' + companyId);
    }

    getAllCompanies() {
        return this.http.get('agri/getAllCompaniesWithUser');
    }

    listCompaniesFiltered(size, page,  sort, order, companiesData: object) {
        return this.http.post('agri/listAllCompaniesFiltered?page=' + (page-1) + '&size=' + size+ '&sort=' + sort + '&dir=' + order, companiesData);
    }

    getJobsFromCompanyId(companyId: string) {
        return this.http.get('agri/getAllJobsFromCompany?companyId=' + companyId);
    }

    ephash(){
        return this.http.post('agri/ephash', ['string']);
    }

    nonceGen(){
        return this.http.get('agri/nonceGen');
    }
  
    alreadyReviewed(companyId: string) {
        return this.http.get('agri/alreadyReviewed?companyId=' + companyId)
    }

    getReviewsOfCompany(companyId){
        return this.http.get('agri/getReviewsOfCompany?companyId='+ companyId)
    }
}


